import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ItemDetailUI } from '../../components/ItemDetailUI'
import { useMarketplacePreviewData } from '../hooks/useMarketplacePreviewData'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'
import { MarketplaceAccessPageProps } from '@/apis/marketplace-preview/types'

type MarketplaceItemLocationState = {
  item?: MarketplaceItem
}

export function MarketplacePreviewItemDetailsPage({
  mode = 'preview',
}: MarketplaceAccessPageProps) {
  const { itemsQuery } = useMarketplacePreviewData(mode)
  const navigate = useNavigate()

  const location = useLocation()

  const itemFromNavigation = (
    location.state as MarketplaceItemLocationState | null
  )?.item

  const { itemId } = useParams()

  return (
    <PageLoader query={itemsQuery}>
      {(data) => {
        if (!itemId) {
          throw new Error('Item ID is required')
        }

        const selectedItem =
          itemFromNavigation ??
          data.data.find((item) => item.id === parseInt(itemId))

        if (!selectedItem) {
          throw new Error('Item not found')
        }

        return (
          <ItemDetailUI
            data={selectedItem}
            onGoBack={() => navigate(-1)}
            onAddToCart={() => {}}
            buttonAnimated={false}
            showAddToCart={false}
          />
        )
      }}
    </PageLoader>
  )
}
